import React, { JSX } from 'react';
import { Col, Row } from 'reactstrap';
import { ApiAttractionAvailabilityInfo, ApiAvailability } from '@ibe/api';
import useTranslation from '../../../Hooks/useTranslation';
import fallback from '../../../../_Translations/generated/closure-dates.en.t.json';
import Keys from '../../../../_Translations/generated/closure-dates.en.t.json.keys';
import DateDisplay from '../../UI/DateDisplay/DateDisplay';
import useConfig from '../../../Hooks/useConfig';
import useAppService from '../../../Hooks/useAppService';

export interface ClosureDatesProps {
  closureDates: ApiAttractionAvailabilityInfo[];
}

const ClosureDates = (props: ClosureDatesProps): JSX.Element => {
  const { closureDates } = props;

  const config = useConfig();
  const appService = useAppService();

  const defaultFormat = config.displayFormatDate[appService.lang.replace('-', '_')];
  const DATE_DISPLAY_FORMAT =
    'ddd, ' + (defaultFormat ? defaultFormat : config.displayFormatDate[config.defaultLanguage]);

  const { t } = useTranslation('closure-dates', fallback, Keys);

  function isOpen(availability: ApiAvailability): boolean {
    return availability.availability > 0;
  }

  function buildVacancyStatusLabel(availability: ApiAvailability): JSX.Element {
    if (isOpen(availability)) {
      return (
        <span className="ml-2 iso__closure-dates-small-view__open-availability">
          {t(Keys.open)}
        </span>
      );
    } else {
      return (
        <span className="ml-2 iso__closure-dates-small-view__closed-availability">
          {t(Keys.closed)}
        </span>
      );
    }
  }

  function buildClosureDatesSmallViewItem(attraction: ApiAttractionAvailabilityInfo): JSX.Element {
    return (
      <Row className="iso__closure-dates-small-view">
        <Col>
          <Row className="justify-content-center">
            <div className="iso__closure-dates-small-view__label font-weight-bold">
              {attraction.title}
            </div>
          </Row>
          {attraction?.availabilities?.map(availability => (
            <Row className="justify-content-center">
              <DateDisplay date={availability.date} format={DATE_DISPLAY_FORMAT} />
              {buildVacancyStatusLabel(availability)}
            </Row>
          ))}
        </Col>
        <hr className="iso__closure-dates-small-view__elements-divider w-100" />
      </Row>
    );
  }

  return <Col>{closureDates.map(closureDate => buildClosureDatesSmallViewItem(closureDate))}</Col>;
};

export default ClosureDates;
